import React, { useState, useEffect } from 'react';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

// material-ui icons
import { LocalShipping, Save } from '@material-ui/icons';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';
import moment from 'moment';
import { wsGetAll, wsUrl, wsFindBy, wsCreate } from 'services/WService';

import ModalFull from 'components/Tvendo/Common/ModalFull.js';
import { useNavigate, useParams } from 'react-router-dom';
import { wsGet } from 'services/WService';
// import OrdersMap from './components/OrdersMap';
import { wsUpdate } from 'services/WService';
import Route from './Childs/Route';
import Orders from './Childs/Orders';

const useStyles = makeStyles({
  ...styles,
  float: {
    margin: 'auto',
    float: 'right',
  },
  color: {
    color: 'black',
  },
  hr: {
    width: '95%',
  },
});

function AddOrdersProg(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [notify, showNotify] = useToasty();
  const { id } = useParams();
  const [sheetDistribution, setSheetDistribution] = useState({});
  const [workDay, setWorkDay] = useState(null);
  const [orders, setOrders] = useState([]);
  const [sheets, setSheets] = useState([]);
  const [checkedRoutes, setCheckedRoutes] = useState([]);
  const [checkedOrders, setCheckedOrders] = useState([]);
  const [dataFilter, setDataFiter] = useState({
    start_date: moment().subtract(2, 'days').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD')
  });

  const [data, setData] = useState({
    base_zone_id: 1,
    scheduled_date: moment().format('YYYY-MM-DD'),
  });

  // #region Listado de datos desde API
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [jefeMercas, setJefeMercas] = useState([]);
  const [jefeDists, setJefeDists] = useState([]);
  const [refreshRoutes, setRefreshRoutes] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [dataKey, setDataKey] = useState(0);

  async function listZone() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      setZones(response.data);
    }
  }

  async function getWarehouses(idZone) {
    let response = await wsFindBy(`base/zone/${idZone}/warehouse`);
    if (response.success) setWarehouses([response.data]);
  }

  async function listVehicles(idZone) {
    let response = await wsFindBy('prog/vehicle', { base_zone_id: idZone });
    if (response.success) {
      setVehicles(response.data);
    }
  }

  async function listManagers(idZone) {
    let response = await wsFindBy('prog/distribution-staff', { base_zone_id: idZone });
    if (response.success) {
      setJefeMercas(response.data.filter((item) => item.base_employee_positon_id == '1'));
      setJefeDists(response.data.filter((item) => item.base_employee_positon_id == '2'));
    }
  }
  //#endregion

  //#region visualizar pdf
  const [urlPDF, setUrlPDF] = useState({ consolidate: '' });
  const [showConsolidate, setShowConsolidate] = useState(false);

  async function getUrlConsolidate(arrayOrders) {
    let orderIds = arrayOrders.map((item) => item.id);
    let valueSearch = {
      sale_order_id: orderIds,
      prog_vehicle_id: data.prog_vehicle_id || '',
      prog_distribution_staff_id_manager: data.prog_distribution_staff_id_manager || '',
      prog_distribution_staff_id_inventory_manager:
        data.prog_distribution_staff_id_inventory_manager || '',
    };
    for (var clave in valueSearch) {
      if (valueSearch[clave] == null || valueSearch[clave] == '') {
        delete valueSearch[clave]; //eliminamos las claves nulas
      }
    }
    let urlPdfConsolidate = await wsUrl('prog/consolidated', valueSearch);
    setUrlPDF({ consolidate: urlPdfConsolidate });
    setShowConsolidate(true);
  }

  function clearData() {
    setCheckedRoutes([]);
    setCheckedOrders([]);
    const {
      prog_vehicle_id,
      prog_distribution_staff_id_inventory_manager,
      prog_distribution_staff_id_manager,
      ...rest
    } = data;
    setData(rest);
    setRefreshRoutes(!refreshRoutes);
  }
  //#endregion

  async function save() {
    let orderIds = checkedOrders.map((order) => order.id);
    setGenerating(true);
    let res = await wsCreate(`prog/sheet-distribution/${id}/add-orders`, {
      orders: orderIds,
    });
    setGenerating(false);

    if (res.success) {
      showNotify(res.message);
      navigate('/admin/reparto/operaciones/programacion/');
    } else {
      showNotify(res.message, 'error');
    }
  }

  async function getSheetDistribution() {
    let res = await wsGet('prog/sheet-distribution', id, { with_orders: 'Y' });
    if (res.success) {
      setSheetDistribution(res.data);
      setWorkDay(res.data.workDay);
      setOrders(res.data.orders);
    }
  }

  useEffect(() => {
    getSheetDistribution();
    // listZone();
    // getWarehouses(data.base_zone_id);
    // listVehicles(data.base_zone_id);
    // listManagers(data.base_zone_id);
  }, []);

  return (
    <>
      <Toasty action={notify} />
      <ModalFull
        title="Hoja consolidado"
        open={showConsolidate}
        setOpen={setShowConsolidate}
        iframe
      >
        <iframe
          src={showConsolidate ? urlPDF?.consolidate : undefined}
          width="100%"
          height="100%"
          title="Pdf"
        >
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>

      <form
        id="consolidate"
        onSubmit={(e) => {
          e.preventDefault();
          save(data, checkedOrders);
        }}
      >
        {/* Info general de la hoja reparto */}
        <GridContainer>
          {/* Fecha inicial */}
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <TextField
              label="Fecha Inicial"
              type="date"
              fullWidth
              size="small"
              value={dataFilter.start_date}
              onChange={(e) =>
                setDataFiter({
                  ...dataFilter,
                  start_date: e.target.value,
                })
              }
            />
          </GridItem>
          {/* Fecha final */}
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <TextField
              label="Fecha Final"
              type="date"
              fullWidth
              size="small"
              value={dataFilter.end_date}
              onChange={(e) =>
                setDataFiter({
                  ...dataFilter,
                  end_date: e.target.value,
                })
              }
            />
          </GridItem>
          {/* Zonas */}
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Zona</InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                value={sheetDistribution.base_zone_id || ''}
                disabled
              >
                {sheetDistribution.id !== undefined && (
                  <MenuItem value={sheetDistribution.base_zone_id}>
                    {sheetDistribution.base_zone_description}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </GridItem>
          {/* Almacén */}
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel>Almacén</InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                value={sheetDistribution.logi_warehouse_id || ''}
                disabled
              >
                {sheetDistribution.id !== undefined && (
                  <MenuItem value={sheetDistribution.logi_warehouse_id}>
                    {sheetDistribution.logi_warehouse_name}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </GridItem>
          {/* Ver consolidado / Generar */}
          <GridItem lg={4} sm={4} xl={4} xs={12}>
            <div className={classes.float}>
              <Button
                type="submit"
                form="consolidate"
                color={props.themeContext.buttonColorSuccess}
                round
                className={classes.marginRight}
                disabled={workDay !== null || generating}
              >
                <Save className={classes.icons} />
                Agregar pedidos
              </Button>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        {/* Vehículo */}
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <LocalShipping />
            </CardIcon>
            <h4 className={classes.color}>Vehículo</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem lg={4} sm={4} xl={4} xs={12}>
                <FormControl fullWidth size="small" required>
                  <InputLabel>Vehículo</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={sheetDistribution.prog_vehicle_id || ''}
                    disabled
                  >
                    {sheetDistribution.id !== undefined && (
                      <MenuItem value={sheetDistribution.prog_vehicle_id}>
                        {sheetDistribution.vehicle.name}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Cod. Vehículo"
                  fullWidth
                  size="small"
                  value={sheetDistribution.prog_vehicle_code || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Capacidad (Peso)"
                  fullWidth
                  size="small"
                  value={sheetDistribution.vehicle?.weight || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Modelo"
                  fullWidth
                  size="small"
                  value={sheetDistribution.vehicle?.model || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Color"
                  fullWidth
                  size="small"
                  value={sheetDistribution.vehicle?.color || ''}
                  disabled
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={3} xl={3} xs={12}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Jefe Reparto</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={sheetDistribution.prog_distribution_staff_id_manager || ''}
                    disabled
                  >
                    {sheetDistribution.id !== undefined && (
                      <MenuItem value={sheetDistribution.prog_distribution_staff_id_manager}>
                        {sheetDistribution.manager_name}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  disabled
                  label="lic. Conducir"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={sheetDistribution.manager_license || ''}
                />
              </GridItem>
              <GridItem sm={3} xl={2} xs={12}>
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Encargado de mercadería</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    value={sheetDistribution.prog_distribution_staff_id_inventory_manager || ''}
                    disabled
                  >
                    {sheetDistribution.id !== undefined && (
                      <MenuItem
                        value={sheetDistribution.prog_distribution_staff_id_inventory_manager}
                      >
                        {sheetDistribution.inventory_manager_name}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </form>
      <br />
      <Route
        idZone={sheetDistribution.base_zone_id}
        dataFilter={dataFilter}
        checkedRoutes={checkedRoutes}
        setCheckedRoutes={setCheckedRoutes}
        refreshRoutes={refreshRoutes}
      />
      <br />
      <Orders
        idZone={sheetDistribution.base_zone_id}
        dataFilter={dataFilter}
        checkedRoutes={checkedRoutes}
        checkedOrders={checkedOrders}
        setCheckedOrders={setCheckedOrders}
      />
      {/* {workDay !== null ? (
        <h1>Hoja asignada a una jornada</h1>
      ) : (
        <OrdersMap
          orders={orders}
          setOrders={setOrders}
          routes={sheetDistribution.routes || []}
          sheetDistribution={sheetDistribution}
          sheets={sheets}
          setSheets={setSheets}
        />
      )} */}
    </>
  );
}

export default WithApp(AddOrdersProg);
